import { Button } from "@/components/ui/button";
import { CloseFilled, Maximize } from "@carbon/icons-react";
import { useMemo } from "react";
import {
  ContentTypeEnums,
  FolderMenuActions,
} from "../constants/lib.constants";
import { IContent } from "../types/lib.types";

export interface IFolderMenuItemProps {
  key: FolderMenuActions;
  label: string;
  icon: React.ElementType;
}
interface IFolderMenusProps {
  hideFolderAction?: boolean;
  items: IFolderMenuItemProps[];
  contentSelected: IContent;
  onClick: (action: FolderMenuActions) => void;
}

export default function FolderMenus({
  hideFolderAction,
  items,
  contentSelected,
  onClick,
}: IFolderMenusProps) {
  const isFolder = useMemo(
    () => contentSelected.type === ContentTypeEnums.FOLDER,
    [contentSelected]
  );
  return (
    <div className="flex flex-row justify-between border-b-[1px] sticky top-0 bg-white z-[10] w-full">
      <div className="flex flex-row items-center space-x-4 p-4 overflow-x-auto">
        {isFolder && !hideFolderAction && (
          <Button
            size="sm"
            variant="ghost"
            onClick={() => onClick(FolderMenuActions.Open)}
            className="text-black bg-transparent"
          >
            <Maximize className="mr-2 h-4 w-4" /> Mở thư mục
          </Button>
        )}
        {items.map((item) => (
          <Button
            key={item.key}
            size="sm"
            variant="ghost"
            className="text-black bg-transparent"
            onClick={() => onClick?.(item.key)}
          >
            <item.icon className="mr-2 h-4 w-4" /> {item.label}
          </Button>
        ))}
      </div>
      <div className="flex flex-row items-center text-primary pr-5">
        <Button
          variant="ghost"
          className="rounded-full bg-transparent"
          onClick={() => onClick?.(FolderMenuActions.DeSelect)}
        >
          <CloseFilled className="text-primary" />
        </Button>
        <span className="text-sm whitespace-nowrap">1 Được chọn</span>
      </div>
    </div>
  );
}
